"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputValidationError = void 0;
const tslib_1 = require("tslib");
const apigw_models_1 = require("@integration/apigw-models");
const class_validator_1 = require("class-validator");
const HttpError_1 = require("./HttpError");
class InputValidationError extends HttpError_1.HttpError {
    constructor(message, code = 'input_validation', metaData) {
        super(400, code, message, undefined, metaData);
    }
}
tslib_1.__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({ defaultValue: 400, description: 'HTTP Code' }),
    tslib_1.__metadata("design:type", Number)
], InputValidationError.prototype, "statusCode", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({ example: 'input_validation', description: 'HTTP Status' }),
    tslib_1.__metadata("design:type", String)
], InputValidationError.prototype, "code", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({
        example: 'An instance of ApiBodyRequest has failed the validation:\n - property resourceId has failed the following constraints: isUuid \n',
        description: 'Message describing which input(s) fail the validation',
    }),
    tslib_1.__metadata("design:type", Object)
], InputValidationError.prototype, "message", void 0);
exports.InputValidationError = InputValidationError;
